.container {
  padding: var(--space-8);
  border: 1px dashed var(--grey-600);
  position: relative;
  display: inline-flex;
}

.images-container {
  gap: var(--space-8);
}

.image-container {
  position: relative;
}

.image {
  height: 108px;
  width: 70px;
}

.landscape-image {
  width: 108px;
  height: 70px;
}

.text-container {
  position: absolute;
  inset: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.text {
  color: var(--white);
  text-align: center;
  background: var(--grey-900);
  width: 68px;
  padding: var(--space-4) var(--space-8);
}

.landscape-text {
  width: 104px;
}
